import {Directive} from '@angular/core';

@Directive()
/**
 * @deprecated `LayoutModule`에 통합
 */
export abstract class AppComponentBase {
	constructor(...args: any[]) {
		throw Error('Does not required implements `AppComponentBase` for State Class Names');
	}
}
